/**
 * Extracts site-dependent for-report-view-page route-based parameters
 * and injects them into the DashboardHostRouteShell.
 *
 */

import SiteReportPage from '../../../dashboard/SiteReportPage';
import { DashboardHostRouteShell } from '../../../dashboard/DashboardHostRouteShell';
import { useParams } from 'react-router-dom';

// -- helper functions --

function parseRouteId(value: string | undefined): number | null {
  if (value === undefined) {
    return null;
  }

  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
}

// -- main component --

export default function SiteReportRoute() {
  const params = useParams();

  return (
    <DashboardHostRouteShell
      project_id={parseRouteId(params.project_id)}
      site_id={parseRouteId(params.site_id)}
      grid_id={parseRouteId(params.grid_id)}
      mode="site"
      grid_type="reports"
      simplified_view={false}
      dashboard_only_mode={false}
    >
      <SiteReportPage />
    </DashboardHostRouteShell>
  );
}
